import {
    Color,
    Group,
    LinearFilter,
    LinearMipMapLinearFilter,
    Mesh,
    MeshPhongMaterial,
    MeshStandardMaterial,
    Texture,
    sRGBEncoding,
} from "three";

export const updateDoorMaterials = (object: Group, doorTextures: { textureWhiteDoor: Texture; aomapDoor: Texture }) => {
    doorTextures.textureWhiteDoor.magFilter = LinearFilter;
    doorTextures.aomapDoor.magFilter = LinearFilter;
    doorTextures.textureWhiteDoor.minFilter = LinearMipMapLinearFilter;
    doorTextures.aomapDoor.minFilter = LinearMipMapLinearFilter;
    doorTextures.textureWhiteDoor.encoding = sRGBEncoding;
    doorTextures.aomapDoor.encoding = sRGBEncoding;
    object.traverse((elem) => {
        if ((elem as Mesh).isMesh) {
            const mesh = elem as Mesh;
            mesh.receiveShadow = true;
            mesh.castShadow = true;

            if (Array.isArray(mesh.material)) {
                for (let mat of mesh.material) {
                    if (mat.type === "MeshPhongMaterial") {
                        const material = mat as MeshPhongMaterial;
                        material.color = new Color(0xffffff);
                        material.map = doorTextures.textureWhiteDoor;
                        material.aoMap = doorTextures.aomapDoor;
                        material.aoMapIntensity = 0.9;
                        material.shininess = 10;
                        material.flatShading = true;
                        material.needsUpdate = true;
                    }
                }
            } else {
                if (mesh.material.type === "MeshStandardMaterial") {
                    const material = mesh.material as MeshStandardMaterial;
                    material.color = new Color(0xffffff);
                    material.metalness = 0.5;
                    material.roughness = 0.8;
                    material.aoMap = doorTextures.aomapDoor;
                    material.aoMapIntensity = 0.1;
                    material.flatShading = true;
                    material.needsUpdate = true;
                }
            }
        }
    });

    object.userData.isMapLoaded = true;
};
